(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royalty-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('royalty-collection-grid')) {
    class RoyaltyCollectionGrid extends HTMLElement {
      connectedCallback() {
        this.classList.add('rcg--js');
        this.grid = this.querySelector('[data-rcg-grid]');
        this.more = this.querySelector('[data-rcg-more]');
        const sort = this.querySelector('[data-rcg-sort]');
        if (sort) sort.addEventListener('change', () => { sort.form.requestSubmit ? sort.form.requestSubmit() : sort.form.submit(); });
        if (this.more) this.more.addEventListener('click', (e) => { e.preventDefault(); this.loadMore(); });
      }
      async loadMore() {
        if (!this.more || !this.grid) return;
        const next = new URL(this.more.getAttribute('href'), window.location.href);
        next.searchParams.set('section_id', this.dataset.sectionId);
        this.more.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(next.toString(), { headers: { Accept: 'text/html' } });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('[data-rcg-grid] > li');
          items.forEach((li) => this.grid.appendChild(li));
          const nextMore = doc.querySelector('[data-rcg-more]');
          const pageUrl = new URL(window.location.href);
          const pageParam = new URL(this.more.getAttribute('href'), window.location.href).searchParams.get('page');
          if (pageParam) { pageUrl.searchParams.set('page', pageParam); history.replaceState(null, '', pageUrl.toString()); }
          if (nextMore) { this.more.setAttribute('href', nextMore.getAttribute('href')); this.more.removeAttribute('aria-busy'); }
          else { this.more.remove(); this.more = null; }
        } catch (err) {
          window.location.href = this.more.getAttribute('href');
        }
      }
    }
    customElements.define('royalty-collection-grid', RoyaltyCollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royalty-colour-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('royalty-colour-strip')) {
    customElements.define('royalty-colour-strip', class extends HTMLElement {
      connectedCallback() {
        const vp = this.querySelector('[data-rcs-viewport]');
        if (!vp) return;
        vp.addEventListener('pointerdown', () => this.classList.add('is-paused'));
        const resume = () => this.classList.remove('is-paused');
        vp.addEventListener('pointerup', resume);
        vp.addEventListener('pointercancel', resume);
        vp.addEventListener('pointerleave', resume);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => entries.forEach((e) => this.classList.toggle('is-paused', !e.isIntersecting)), { threshold: 0.05 }).observe(this);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royalty-model-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('royalty-model-carousel')) {
    customElements.define('royalty-model-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.rmc__track');
        if (!track) return;
        const arrows = this.querySelectorAll('.rmc__arrow');
        const step = () => { const item = track.querySelector('.rmc__item'); return item ? item.getBoundingClientRect().width + 14 : 240; };
        const update = () => {
          const max = track.scrollWidth - track.clientWidth - 1;
          arrows.forEach(a => { a.disabled = a.dataset.step === '-1' ? track.scrollLeft <= 0 : track.scrollLeft >= max; });
        };
        arrows.forEach(a => a.addEventListener('click', () => track.scrollBy({ left: Number(a.dataset.step) * step() * 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        let down = false, startX = 0, startScroll = 0, moved = false, pointerId = null;
        track.addEventListener('pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; pointerId = e.pointerId;
        });
        track.addEventListener('pointermove', e => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 6) {
            moved = true; track.classList.add('is-dragging');
            try { track.setPointerCapture(pointerId); } catch (err) {}
          }
          if (moved) track.scrollLeft = startScroll - dx;
        });
        const release = e => {
          if (!down) return; down = false;
          if (moved) {
            e.preventDefault();
            try { track.releasePointerCapture(pointerId); } catch (err) {}
            setTimeout(() => { track.classList.remove('is-dragging'); moved = false; }, 50);
          }
        };
        track.addEventListener('pointerup', release);
        track.addEventListener('pointercancel', release);
        track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royalty-model-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('royalty-model-selector')) {
    customElements.define('royalty-model-selector', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.cleanup) this.cleanup();
        const form = this.querySelector('form');
        if (!form) return;
        const trigger = form.querySelector('.ryl-finder__trigger');
        const menu = form.querySelector('.ryl-finder__menu');
        const options = Array.from(menu.querySelectorAll('[role="option"]'));
        const button = form.querySelector('[type="submit"]');
        const value = trigger.querySelector('.ryl-finder__value');
        const controller = new AbortController();
        const listen = (target, type, callback, extra = {}) => target.addEventListener(type, callback, { ...extra, signal:controller.signal });
        let selected = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
        let active = 0, opened = false, search = '', searchTimer, animation;
        const place = () => {
          if (!opened) return;
          const rect = trigger.getBoundingClientRect();
          const viewport = window.visualViewport;
          const top = viewport?.offsetTop || 0, left = viewport?.offsetLeft || 0;
          const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
          const below = top + height - rect.bottom - 20;
          menu.style.width = Math.min(rect.width, width - 24) + 'px';
          menu.style.maxHeight = Math.max(52, Math.min(340, below)) + 'px';
          menu.style.left = Math.max(left + 12, Math.min(rect.left, left + width - menu.offsetWidth - 12)) + 'px';
          menu.style.top = (rect.bottom + 8) + 'px';
          menu.style.transformOrigin = 'top center';
        };
        const highlight = (index, scroll = true) => {
          active = Math.max(0, Math.min(options.length - 1, index));
          options.forEach((option, i) => option.toggleAttribute('data-active', i === active));
          trigger.setAttribute('aria-activedescendant', options[active].id);
          if (scroll) {
            const row = options[active];
            const rowTop = row.offsetTop, rowBottom = rowTop + row.offsetHeight;
            if (rowTop < menu.scrollTop) menu.scrollTop = rowTop;
            else if (rowBottom > menu.scrollTop + menu.clientHeight) menu.scrollTop = rowBottom - menu.clientHeight;
          }
        };
        const close = () => {
          opened = false;
          animation?.cancel();
          if (menu.hidePopover && menu.matches(':popover-open')) menu.hidePopover();
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.removeAttribute('aria-activedescendant');
          search = ''; clearTimeout(searchTimer);
        };
        const open = (index = selected < 0 ? 0 : selected) => {
          if (!options.length) return;
          document.dispatchEvent(new CustomEvent('royalty:selector-open', { detail:this }));
          opened = true; menu.hidden = false;
          if (menu.showPopover && !menu.matches(':popover-open')) menu.showPopover();
          trigger.setAttribute('aria-expanded', 'true');
          place(); highlight(index);
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
            animation?.cancel();
            animation = menu.animate([{ opacity:0, transform:'scale(.985)' }, { opacity:1, transform:'scale(1)' }], { duration:160, easing:'cubic-bezier(.23,1,.32,1)' });
          }
        };
        const choose = (index) => {
          selected = index;
          options.forEach((option, i) => option.setAttribute('aria-selected', String(i === selected)));
          value.textContent = options[selected].querySelector('.ryl-finder__option-name').textContent;
          button.disabled = false;
          close(); trigger.focus({ preventScroll:true });
        };
        listen(trigger, 'click', () => opened ? close() : open());
        listen(trigger, 'keydown', event => {
          if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : opened ? active + (event.key === 'ArrowDown' ? 1 : -1) : selected < 0 ? (event.key === 'ArrowUp' ? options.length - 1 : 0) : selected;
            if (opened) highlight(next); else open(next);
          } else if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); if (opened) choose(active); else open();
          } else if (event.key === 'Escape') {
            if (opened) { event.preventDefault(); event.stopPropagation(); close(); }
          } else if (event.key === 'Tab') close();
          else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault(); if (!opened) open();
            search += event.key.toLocaleLowerCase(); clearTimeout(searchTimer);
            const index = options.findIndex(option => option.textContent.trim().toLocaleLowerCase().startsWith(search));
            if (index >= 0) highlight(index);
            searchTimer = setTimeout(() => { search = ''; }, 700);
          }
        });
        listen(menu, 'mousedown', event => event.preventDefault());
        listen(menu, 'click', event => {
          const option = event.target.closest('[role="option"]');
          if (option && options.includes(option)) choose(options.indexOf(option));
        });
        listen(menu, 'pointermove', event => {
          if (event.pointerType !== 'mouse') return;
          const option = event.target.closest('[role="option"]');
          if (option) highlight(options.indexOf(option), false);
        });
        listen(document, 'pointerdown', event => { if (!this.contains(event.target)) close(); });
        listen(document, 'focusin', event => { if (!this.contains(event.target)) close(); });
        listen(document, 'royalty:selector-open', event => { if (event.detail !== this) close(); });
        listen(window, 'resize', close);
        listen(window, 'scroll', event => {
          if (!opened || menu.contains(event.target)) return;
          const rect = trigger.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > innerHeight) close(); else place();
        }, { capture:true, passive:true });
        if (window.visualViewport) listen(window.visualViewport, 'resize', close);
        const submit = (event) => {
          event.preventDefault();
          if (selected < 0) { trigger.focus(); open(); return; }
          const url = new URL(options[selected].dataset.url, window.location.origin);
          if (url.protocol === 'https:' || url.protocol === 'http:') window.location.assign(url.href);
        };
        listen(form, 'submit', submit);
        listen(window, 'pageshow', close);
        form.hidden = false;
        button.disabled = selected < 0;
        this.cleanup = () => {
          close(); controller.abort();
        };
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup?.(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royalty-video-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('royalty-video-text')) {
    class RoyaltyVideoText extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.rvt__video') || document.readyState !== 'loading') { this.init(); }
        else { document.addEventListener('DOMContentLoaded', () => this.init(), { once: true }); }
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        this.video = this.querySelector('.rvt__video');
        this.toggle = this.querySelector('.rvt__toggle');
        if (!this.video) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.wantsPlay = this.dataset.autoplay === 'true';
        this.userPaused = !this.wantsPlay;
        if (!this.wantsPlay) { this.video.removeAttribute('autoplay'); this.video.pause(); }
        this.setPressed(this.wantsPlay);
        if (this.toggle) this.toggle.addEventListener('click', () => this.onToggle());
        this.video.addEventListener('playing', () => { this.blocked = false; this.setPressed(true); });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) { if (!this.userPaused) this.play(); }
              else if (!this.video.paused) { this.video.pause(); }
            });
          }, { threshold: 0.25 });
          this.io.observe(this);
        } else if (this.wantsPlay) { this.play(); }
        const retry = () => { if (this.blocked && !this.userPaused) this.play(); };
        document.addEventListener('touchstart', retry, { passive: true, once: true });
        document.addEventListener('click', retry, { once: true });
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      play() {
        const p = this.video.play();
        if (p && p.catch) p.catch(() => { this.blocked = true; this.setPressed(false); });
      }
      onToggle() {
        if (this.video.paused) { this.userPaused = false; this.play(); this.setPressed(true); }
        else { this.userPaused = true; this.video.pause(); this.setPressed(false); }
      }
      setPressed(on) {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        this.toggle.setAttribute('aria-label', on ? 'Pause video' : 'Play video');
      }
    }
    customElements.define('royalty-video-text', RoyaltyVideoText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-easy-coding"] && !Shopify.designMode) return;
  try {
    
$('.slider').each(function() {
  var $this = $(this);
  var $group = $this.find('.slide_group');
  var $slides = $this.find('.slide');
  var bulletArray = [];
  var currentIndex = 0;
  var timeout;
  
  function move(newIndex) {
    var animateLeft, slideLeft;
    
    advance();
    
    if ($group.is(':animated') || currentIndex === newIndex) {
      return;
    }
    
    bulletArray[currentIndex].removeClass('active');
    bulletArray[newIndex].addClass('active');
    
    if (newIndex > currentIndex) {
      slideLeft = '100%';
      animateLeft = '-100%';
    } else {
      slideLeft = '-100%';
      animateLeft = '100%';
    }
    
    $slides.eq(newIndex).css({
      display: 'block',
      left: slideLeft
    });
    $group.animate({
      left: animateLeft
    }, function() {
      $slides.eq(currentIndex).css({
        display: 'none'
      });
      $slides.eq(newIndex).css({
        left: 0
      });
      $group.css({
        left: 0
      });
      currentIndex = newIndex;
    });
  }
  
  function advance() {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      if (currentIndex < ($slides.length - 1)) {
        move(currentIndex + 1);
      } else {
        move(0);
      }
    }, 6000);
  }
  
  $('.next_btn').on('click', function() {
    if (currentIndex < ($slides.length - 1)) {
      move(currentIndex + 1);
    } else {
      move(0);
    }
  });
  
  $('.previous_btn').on('click', function() {
    if (currentIndex !== 0) {
      move(currentIndex - 1);
    } else {
      move(3);
    }
  });
  
  $.each($slides, function(index) {
    var $button = $('<a class="slide_btn">&bull;</a>');
    
    if (index === currentIndex) {
      $button.addClass('active');
    }
    $button.on('click', function() {
      move(index);
    }).appendTo('.slide_buttons');
    bulletArray.push($button);
  });
  
  advance();
});

  } catch(e) { console.error(e); }
})();
})();
